<div
  class="flex-row"
  style="margin: 1rem 0"
>
  <mat-form-field appearance="outline">
    <mat-label>Level</mat-label>
    <mat-select
      [value]="currentChangeType()"
      (selectionChange)="onChangeType($event.value)"
    >
      @for (entry of changeLogEntries; track entry.key) {
        <mat-option [value]="entry.key">
          {{ entry.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <input
      matInput
      placeholder="Suche"
      [value]="searchTerm()"
      (input)="searchTerm.set($any($event.target).value)"
    >

    <mat-icon
      svgIcon="{{EsvgFiles.search}}"
      class="blue-icon"
    />
  </mat-form-field>
</div>

<div
  style="overflow-y: auto"
>
  <table class="w-full table-fixed border-collapse">
    <thead>
    <tr>
      <th>Zeitpunkt</th>
      <th>Objekt</th>
      <th>Details</th>
      <th>Nutzer</th>
    </tr>
    </thead>
    <tbody>
      @for (row of compressedRows(); track row) {
        <tr>
          <td
            class="multiline"
            (click)="row.timestamp ? toggleTimestampGroup(row.timeGroupId) : null"
            [style.cursor]="isTimestampClickable(row) ? 'pointer' : 'null'"
          >
            @if (row.timestamp) {
              <mat-icon
                [svgIcon]="isTimeGroupExpanded(row.timeGroupId) ? EsvgFiles.arrow_down : EsvgFiles.arrow_right"
              />

              <span [innerHTML]="splitTimestamp(row.timestamp)[0]"></span>

              <div
                [innerHTML]="splitTimestamp(row.timestamp)[1]"
                style="margin-left: 24px"
              ></div>
            }
          </td>

          <td
            [title]="row.object"
            (click)="row.object ?
              (isTimeGroupExpanded(row.timeGroupId) ?
                toggleObjectGroup(row.objectGroupId) :
                toggleTimestampGroup(row.timeGroupId)) :
              null"
            [style.cursor]="row.object ? 'pointer' : 'default'"
          >
            @if (row.object) {
              <span class="object-cell-content">
                <mat-icon
                  [svgIcon]="isObjectGroupExpanded(row.timeGroupId, row.objectGroupId) ?
                  EsvgFiles.arrow_down : EsvgFiles.arrow_right"
                />

              <span
                class="object-text"
                [class.truncate-multiline]="!!row?.timestamp"
                [innerHTML]="highlightMatches(row.object)"
              ></span>
              </span>
            }
          </td>

          <td
            [title]="expandedDetails().has(row.objectGroupId + row.details) ? '' : row.details"
            (click)="toggleDetailsRow(row.objectGroupId + row.details)"
            [class.multiline]="expandedDetails().has(row.objectGroupId + row.details)"
          >
            <div
              [class.truncate-multiline]="!!row?.timestamp && !expandedDetails().has(row.objectGroupId + row.details)"
              [innerHTML]="highlightMatches(row.details)"
            ></div>
          </td>

          <td [innerHTML]="highlightMatches(row.user)">
            <div
              [class.truncate-multiline]="!!row?.timestamp"
              [innerHTML]="highlightMatches(row.user)"
            ></div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
